var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.parseTipsShow,
          expression: "parseTipsShow"
        }
      ],
      ref: "parseTips",
      staticClass: "torrent-parse",
      attrs: { id: "parseTips" }
    },
    [
      _c("i", {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: true,
            expression: "true"
          }
        ],
        staticClass: "torrent-parse-loadding"
      }),
      _vm._v(" "),
      _c("div", { ref: "parseText", staticClass: "torrent-parse-text" }, [
        _vm._v(_vm._s(_vm.$t("language.remoteTask.parseMagnetRunning")))
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "title" }, [
        _c("div", {
          staticClass: "icon white-close dialog-close",
          on: {
            click: function($event) {
              return _vm.close()
            }
          }
        })
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7e167ae8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e167ae8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/remote_task_popups/parse_tips.vue
// module id = null
// module chunks = 